class IdbStore {
  private data = new Map<string, any>();
  async set(key: string, value: unknown) {
    this.data.set(key, structuredClone(value));
    return Promise.resolve();
  }

  async setMany(entries: [string, unknown][]) { for (const [key, value] of entries) await this.set(key, value); }
  async get<T = unknown>(key: string): Promise<T | undefined> {
    return Promise.resolve(structuredClone(this.data.get(key)) as T | undefined);
  }

  async getMany<T = unknown>(keys: string[]) { return Promise.all(keys.map((key) => this.get<T>(key))); }
  async clear() {
    this.data.clear();
    return Promise.resolve();
  }

  async del(key: string) {
    this.data.delete(key);
    return Promise.resolve();
  }

  async delMany(keys: string[]) {
    keys.forEach((key) => this.data.delete(key));
    return Promise.resolve();
  }

  async entries() { return Promise.resolve(structuredClone([...this.data.entries()])); }
  async keys() { return Promise.resolve([...this.data.keys()]); }
  async values<T = unknown>() { return Promise.resolve(structuredClone([...this.data.values()]) as T[]); }
  async update<T = unknown>(key: string, updater: (old: T | undefined) => T) {
    this.data.set(key, structuredClone(updater(structuredClone(this.data.get(key)) as T | undefined)));
    return Promise.resolve();
  }
}
export const MAIN_IDB_STORE = new IdbStore();
export const PASSCODE_IDB_STORE = new IdbStore();
